<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Daily report list' : '日报审批列表'"
        name="one"
      >
        <div class="daily-report">
          <div class="top">
            <el-radio-group
              v-model="dailyTableParams.type"
              size="small"
              @change="dailyTableParamsTypeChange"
            >
              <el-radio-button :label="0">车间日报</el-radio-button>
              <el-radio-button :label="1">其他日报</el-radio-button>
            </el-radio-group>
            <div class="input">
              <p class="p">
                <span class="span1">{{
                  $lange == "en" ? "Department" : "部门"
                }}</span>
                <el-cascader
                  size="mini"
                  :options="classList"
                  :show-all-levels="false"
                  :placeholder="
                    $lange == 'en' ? 'Please select department' : '请选择部门'
                  "
                  change-on-select
                  @change="selectChange"
                  clearable
                ></el-cascader>
              </p>
              <p class="p">
                <span>员工</span>
                <el-input
                  size="mini"
                  v-model="dailyTableParams.userName"
                  :placeholder="
                    $lange == 'en'
                      ? 'Please enter staff name'
                      : '请输入员工名称'
                  "
                ></el-input>
                <!--                        <cc-selector :config="staffSelectorConfig"-->
                <!--                                     placeholder="请选择员工"-->
                <!--                                     v-model="dailyTableParams.value" />-->
              </p>
              <p class="p">
                <span>{{ $lange == "en" ? "Status" : "状态" }}</span>
                <el-select
                  size="mini"
                  v-model="dailyTableParams.isAudit"
                  :placeholder="
                    $lange == 'en'
                      ? 'Please select order status'
                      : '请选择订单状态'
                  "
                  clearable
                >
                  <el-option label="全部" value></el-option>
                  <el-option label="未审核" :value="0"></el-option>
                  <el-option label="审核通过" :value="1"></el-option>
                  <el-option label="审核不通过" :value="2"></el-option>
                </el-select>
              </p>
              <p class="p">
                <span>{{ $lange == "en" ? "Time" : "时间" }}</span>
                <el-date-picker
                  size="mini"
                  v-model="timeValue"
                  @change="timeChange"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </p>
              <p>
                <el-button
                  type="primary"
                  size="mini"
                  @click="doSearch"
                  class="button"
                  >{{ $lange == "en" ? "Search" : "搜索" }}</el-button
                >
                <el-button size="mini" type="primary" @click="exportReport">{{
                  $lange == "en" ? "Export Report" : "导出日报"
                }}</el-button>
              </p>
            </div>
          </div>
          <div class="bottom" v-show="dailyTableParams.type === 0">
            <cc-table
              :config="dailyTableConfig"
              :params="dailyTableParams1"
              :refeshParams="refeshParams"
            ></cc-table>
          </div>
          <div class="bottom" v-show="dailyTableParams.type === 1">
            <cc-table
              :config="dailyOtherTableConfig"
              :params="dailyTableParams2"
              :refeshParams="refeshParams"
            ></cc-table>
          </div>
          <div class="btn-group"></div>
          <el-dialog
            :title="$lange == 'en' ? 'Report description' : '日报详情'"
            :visible.sync="editDialog"
            width="80%"
            @closed="dialogClose"
            append-to-body
          >
            <div class="edit-dialog">
              <template v-if="!isBatch && editData">
                <div class="title_data">
                  <div class="li">
                    <span>{{ language("awaitDaily_editMyDaily.部门") }}:</span
                    >{{ editData.deptName }}
                  </div>
                  <div class="li">
                    <span>{{ language("awaitDaily_editMyDaily.提交人") }}:</span
                    >{{ editData.userName }}
                  </div>
                  <div class="li li_time">
                    <span
                      >{{ language("awaitDaily_editMyDaily.日报日期") }}:</span
                    >
                    {{ moment(editData.dailyTime).format("YYYY-MM-DD") }}
                  </div>
                  <div class="li" style="width: 224px">
                    <span>{{ language("awaitDaily_editMyDaily.状态") }}:</span
                    ><el-tag size="mini" :type="status(editData.isAudit)">{{
                      ["未审核", "审核通过", "审核不通过"][editData.isAudit]
                    }}</el-tag>
                    <span class="text">{{ getDataRemark(editData) }}</span>
                  </div>
                </div>
                <div class="title_wrap">
                  <h4>{{ language("awaitDaily_editMyDaily.日报内容") }}</h4>
                </div>
                <div class="lists-item">
                  <div
                    class="list flex-between"
                    v-for="(
                      item, itemIndex
                    ) in editData.workshopDailyDetailsList"
                  >
                    <div class="list-left">
                      <div class="audit_wrap">
                        <div class="itme" style="width: 400px">
                          {{ language("workShop.审核人") }}：{{
                            item.auditName
                          }}
                        </div>
                        <div class="itme" style="width: 200px">
                          {{ $lange == "en" ? "Status" : "状态" }}：
                          <el-tag
                            size="mini"
                            :type="status(item.isAuditView)"
                            >{{
                              [
                                "未审核",
                                "审核通过",
                                "审核不通过",
                                "不需要审核",
                              ][item.isAuditView]
                            }}</el-tag
                          >
                        </div>
                        <div
                          class="itme"
                          style="width: 200px"
                          v-if="item.isAudit == 2 || item.isAudit == 1"
                        >
                          {{
                            $lange == "en" ? "Approval opinion" : "审批意见"
                          }}：{{ item.auditOpinion }}
                        </div>
                        <div
                          class="itme"
                          style="width: 200px"
                          v-if="
                            item.isAudit == 0 &&
                            ((isAudit && adminUser.roleTips == 'management') ||
                              adminUser.id == item.auditId)
                          "
                        >
                          {{ $lange == "en" ? "Operation" : "操作" }}：
                          <el-button
                            v-if="item.editType == 1"
                            size="mini"
                            @click="openAudit(item, false, itemIndex)"
                            >{{
                              $lange == "en" ? "Edit Audit" : "修改审核内容"
                            }}
                          </el-button>
                          <el-button
                            v-else
                            size="mini"
                            @click="openAudit(item, false, itemIndex)"
                            >{{ $lange == "en" ? "Audit" : "审核" }}
                          </el-button>
                        </div>
                      </div>
                      <div class="back">
                        <div
                          class="row-clip"
                          :title="`${item.workshopProject.name} —— ${item.workshopUnit.name} —— ${item.workshopOrder.numbering} —— ${item.workshopProcess.content}`"
                        >
                          <span class="font_weight"
                            >{{ $lange == "en" ? "Content" : "内容" }}:</span
                          >
                          {{
                            `${item.workshopProject.name} —— ${item.workshopUnit.name} —— ${item.workshopOrder.numbering} —— ${item.workshopProcess.content}`
                          }}
                        </div>
                        <div
                          class="li"
                          v-for="(t, index) in item.workshopDailyDetailsRelList"
                        >
                          <div style="width: 400px">
                            {{ t.childProcessName }}
                          </div>
                          <div style="width: 400px">
                            {{ language("workShop.实际工时") }}:{{
                              t.actualWorkingHours
                            }}
                          </div>
                          <div style="width: 400px">
                            {{ language("workShop.上限工时") }}:{{
                              t.childProcessLimitWorkingHours
                            }}
                          </div>
                          <div style="width: 400px">
                            {{ language("workShop.剩余工时") }}:{{
                              t.childProcessSurplusWorkingHours
                            }}
                          </div>
                        </div>
                        <div class="count">
                          {{ language("workShop.阶段实际工时") }}:{{
                            item.actualWorkingHours
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card_box"
                    v-if="editData.workshopDailyDetailsList.length == 0"
                  >
                    <div>无内容</div>
                  </div>
                </div>

                <div class="title_wrap">
                  <h4>{{ language("awaitDaily_editMyDaily.其余事项") }}</h4>
                </div>
                <div class="lists-item">
                  <div
                    class="list flex-between"
                    v-if="editData.somethingElseList.length > 0"
                  >
                    <div class="list-left">
                      <div class="audit_wrap">
                        <div class="itme" style="width: 400px">
                          {{ language("workShop.审核人") }}：{{
                            editData.auditUserName
                          }}
                        </div>
                        <div class="itme" style="width: 200px">
                          {{ $lange == "en" ? "Status" : "状态" }}：<el-tag
                            size="mini"
                            :type="status(editData.dailyExtAuditView)"
                            >{{
                              [
                                "未审核",
                                "审核通过",
                                "审核不通过",
                                "不需要审核",
                              ][editData.dailyExtAuditView]
                            }}</el-tag
                          >
                        </div>
                        <div
                          class="itme"
                          style="width: 200px"
                          v-if="
                            editData.dailyExtAudit == 2 ||
                            editData.dailyExtAudit == 1
                          "
                        >
                          {{
                            $lange == "en" ? "Approval opinion" : "审批意见"
                          }}：{{ editData.dailyExtOpinion }}
                        </div>
                        <div
                          class="itme"
                          style="width: 200px"
                          v-if="
                            editData.dailyExtAudit == 0 &&
                            ((isAudit && adminUser.roleTips == 'management') ||
                              adminUser.id == editData.auditUserId)
                          "
                        >
                          {{ $lange == "en" ? "Operation" : "操作" }}：
                          <el-button
                            v-if="editData.editType == 1"
                            size="mini"
                            @click="openAudit(editData.somethingElseList, true)"
                            >{{
                              $lange == "en" ? "Edit Audit" : "修改审核内容"
                            }}</el-button
                          >
                          <el-button
                            v-else
                            size="mini"
                            @click="openAudit(editData.somethingElseList, true)"
                            >{{ $lange == "en" ? "Audit" : "审核" }}</el-button
                          >
                        </div>
                      </div>
                      <div class="card_box" style="margin-bottom: 0">
                        <div class="selete_data">
                          <div
                            :class="
                              'li_data ' +
                              (editData.somethingElseList.length - 1 > index
                                ? 'li_data3'
                                : '')
                            "
                            v-for="(itmes, index) in editData.somethingElseList"
                          >
                            <div>
                              <span>{{ itmes.name }}</span>
                            </div>
                            <div class="remark">
                              <span>实际工时：</span>
                              <span
                                >{{ itmes.value
                                }}{{
                                  language("awaitDaily_editMyDaily.小时")
                                }}</span
                              >
                            </div>
                            <div class="remark" v-if="itmes.projectId">
                              {{ language("awaitDaily_editMyDaily.项目") }}：{{
                                itmes.projectName
                              }}
                            </div>
                            <div class="remark" v-if="itmes.unitId">
                              {{ language("awaitDaily_editMyDaily.单元") }}：{{
                                itmes.unitName
                              }}
                            </div>
                            <div class="remark" v-if="itmes.content">
                              {{ language("awaitDaily_editMyDaily.内容") }}：{{
                                itmes.content
                              }}
                            </div>
                            <div class="remark">
                              <span>内容：</span>
                              <div>{{ itmes.remark }}</div>
                            </div>
                            <!-- <div v-if="itmes.name == '其余事项'" class="remark">
                          <div>事项内容：</div>
                          <div>{{ itmes.remark }}</div>
                        </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card_box"
                    v-if="editData.somethingElseList.length == 0"
                  >
                    <div>无内容</div>
                  </div>
                </div>

                <div class="all_count">
                  {{ language("workShop.日报总实际工时") }}：{{
                    getAllCount(editData)
                  }}
                </div>
                <div class="btn-group flex-between">
                  <el-button size="mini" @click="editDialog = false">{{
                    $lange == "en" ? "Cancel" : "取消"
                  }}</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="submitAudit"
                    v-if="
                      isAudit &&
                      (showAuditbutton || adminUser.roleTips == 'management')
                    "
                    >{{ $lange == "en" ? "Submit" : "提交审核结果" }}</el-button
                  >
                </div>
              </template>
            </div>
          </el-dialog>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="language('workShop.班级员工日报')" name="two">
        <template v-if="activeName == 'two'">
          <DailyReportV2></DailyReportV2>
        </template>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="language('workShop.审核日报')"
      :visible.sync="openAuditDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="auditFrom" label-width="80px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditFrom.isAudit">
            <el-radio :label="1">{{
              $lange == "en" ? "adopt" : "审核通过"
            }}</el-radio>
            <el-radio :label="2">{{
              $lange == "en" ? "Not pass" : "审核不通过"
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Approval opinion' : '审批意见'">
          <el-input type="textarea" v-model="auditFrom.auditOpinion"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-group audit_botton">
        <el-button size="mini" @click="openAuditDialog = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="editAudit"
          v-if="isAudit"
          >{{ $lange == "en" ? "Next Step" : "下一步" }}</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('awaitDaily_dailyList.关闭日报')"
      :visible.sync="closeDialog"
      width="70%"
      append-to-body
    >
      <div>
        <h2>{{ language("awaitDaily_dailyList.请确认是否关闭此日报") }}</h2>
        <p>
          {{
            language("awaitDaily_dailyList.关闭之后该员工将无法填写日期日报")
          }}
        </p>
        <div class="userDay">
          <h3>
            {{ language("awaitDaily_dailyList.所在部门") }}：{{
              closeData.deptName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.汇报人") }}：{{
              closeData.userName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.日报日期") }}：{{
              getTime(closeData.dailyTime)
            }}
          </h3>
        </div>
        <div class="textarea">
          <el-input
            type="textarea"
            :rows="10"
            :placeholder="
              language('awaitDaily_dailyList.请输入关闭的原因说明比如：休假等')
            "
            v-model="closeData.remark"
          >
          </el-input>
        </div>
      </div>
      <div class="button_wrap">
        <el-button @click="dialog = false">{{
          language("awaitDaily_dailyList.取消")
        }}</el-button>
        <el-button type="primary" @click="doCloseDay">{{
          language("awaitDaily_dailyList.提交")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import remarkDailyReport from "./component/remarkDailyReport.vue";
import DailyReportV2 from "./DailyReportV2";
export default {
  name: "DailyReport",
  components: {
    DailyReportV2,
  },
  data() {
    return {
      showAuditbutton: false,
      type: "",
      dialogEditor: false,
      dialogEditorTatile: "",
      editObj: {},
      editForm: {
        ids: [],
        isAudit: 1,
        opinion: "",
      },
      editData: false,
      editDialog: false,
      isAudit: false,
      isBatch: false, //是否是批量
      classList: [],

      moment: moment,
      activeName: "one",
      timeValue: [], //时间选择器
      staffSelectorConfig: {},
      refeshParams: 0,
      dailyTableSelectFun: (row) => {
        let res = false;
        // if(this.formTableConfigParams.selectedIds || row.status === 0){  //编辑的时候为了取消做的兼容
        //     res = true;
        // }
        if (row.isAudit === 0) {
          res = true;
        }
        return res;
      },
      dailyTableParams: {
        deptId: "",
        userName: "",
        startTime: "",
        endTime: "",
        type: 0,
        submitStatus: 1,
        isAudit: "",
      },
      dailyTableParams1: {
        deptId: "",
        userName: "",
        startTime: "",
        endTime: "",
        type: 0,
        submitStatus: 1,
        isAudit: "",
      },
      dailyTableParams2: {
        deptId: "",
        userName: "",
        startTime: "",
        endTime: "",
        type: 1,
        submitStatus: 1,
        isAudit: "",
      },
      dailyTableConfig: {
        // selection: [],
        showPager: true,
        pageSize: 10,
        // selectedText: true,
        api: "admin/fsb/workshop/daily/query",
        columns: [
          {
            prop: "deptName",
            lable: this.$lange == "en" ? "Department" : "部门",
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Submitter" : "提交人",
          },
          {
            lable: this.$lange == "en" ? "Presentation time" : "提报时间",
            render: (row) => {
              return moment(row.dailyTime).format("YYYY-MM-DD");
            },
          },

          {
            prop: "isAudit",
            lable: this.$lange == "en" ? "Audit status" : "审核状态",
            type: "tag",
            options: [
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Unaudited" : "未审核",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Audit pass" : "审核通过",
              },
              {
                tagType: "danger",
                text: this.$lange == "en" ? "Audit failed" : "审核不通过",
              },
            ],
          },

          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            minWidth: 100,
            componentName: remarkDailyReport,
            type: "component",
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View and review" : "查看并审核",
            check: (row) => {
              let res = false;
              let isAudit = false;
              if (row.isAudit == 0) {
                isAudit = true;
                if (
                  this.adminUser.id == row.auditUserId &&
                  row.dailyExtAudit == 0
                ) {
                  res = true;
                }
                if (!res) {
                  for (
                    let index = 0;
                    index < row.workshopDailyDetailsList.length;
                    index++
                  ) {
                    if (
                      row.workshopDailyDetailsList[index].auditId ==
                        this.adminUser.id &&
                      row.workshopDailyDetailsList[index].isAudit == 0
                    ) {
                      res = true;
                      break;
                    }
                  }
                }
                return res && isAudit ? true : false;
              } else {
                return false;
              }
            },
            click: (row) => {
              let showAuditbutton = false;
              for (
                let index = 0;
                index < row.workshopDailyDetailsList.length;
                index++
              ) {
                row.workshopDailyDetailsList[index].isAuditView =
                  row.workshopDailyDetailsList[index].isAudit;
                if (
                  row.workshopDailyDetailsList[index].auditId ==
                  this.adminUser.id
                ) {
                  showAuditbutton = true;
                }
              }
              if (this.adminUser.id == row.auditUserId) {
                showAuditbutton = true;
              }
              this.showAuditbutton = showAuditbutton;
              row.dailyExtAuditView = row.dailyExtAudit;
              this.auditObj = {};
              this.auditFrom = {};
              this.editData = row;
              this.editForm.ids = [row.id];
              this.editDialog = true;
              this.isAudit = true;
            },
          },
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            check: (row) => {
              let res = false;
              let isAudit = false;
              if (row.isAudit == 0) {
                isAudit = true;
                if (
                  this.adminUser.id == row.auditUserId &&
                  row.dailyExtAudit == 0
                ) {
                  res = true;
                }
                if (!res) {
                  for (
                    let index = 0;
                    index < row.workshopDailyDetailsList.length;
                    index++
                  ) {
                    if (
                      row.workshopDailyDetailsList[index].auditId ==
                        this.adminUser.id &&
                      row.workshopDailyDetailsList[index].isAudit == 0
                    ) {
                      res = true;
                      break;
                    }
                  }
                }
                return res && isAudit ? false : true;
              } else {
                return false;
              }
            },
            click: (row) => {
              for (
                let index = 0;
                index < row.workshopDailyDetailsList.length;
                index++
              ) {
                row.workshopDailyDetailsList[index].isAuditView =
                  row.workshopDailyDetailsList[index].isAudit;
              }
              row.dailyExtAuditView = row.dailyExtAudit;

              this.auditObj = {};
              this.auditFrom = {};
              this.editData = row;
              this.editDialog = true;
            },
          },
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            check: (row) => {
              let res = false;
              if (row.isAudit !== 0) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              for (
                let index = 0;
                index < row.workshopDailyDetailsList.length;
                index++
              ) {
                row.workshopDailyDetailsList[index].isAuditView =
                  row.workshopDailyDetailsList[index].isAudit;
              }
              row.dailyExtAuditView = row.dailyExtAudit;

              this.auditObj = {};
              this.auditFrom = {};
              this.editData = row;
              this.editDialog = true;
            },
          },
          // {
          //   name: "", //占位
          // },
          {
            name: this.language("awaitDaily_dailyList.关闭"),
            click: (row) => {
              this.closeData = row;
              this.closeDialog = true;
            },
            check: (e) => {
              let type = false;
              if (e.isAudit == 2 && this.adminUser.roleTips =='squadLeader') {
                type = true;
              }
              return type;
            },
          },
        ],
      },
      dailyOtherTableConfig: {
        showPager: true,
        pageSize: 10,
        api: "admin/fsb/workshop/daily/query",
        columns: [
          {
            prop: "deptName",
            lable: this.$lange == "en" ? "Department" : "部门",
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Submitter" : "提交人",
          },
          // {
          //   lable: this.$lange == "en" ? "Report description" : "日报详情",
          //   render: (row) => {
          //     let arr = row.somethingElseList;
          //     let res = "";
          //     for (let i in arr) {
          //       res += `${arr[i].name}: ${arr[i].value.toFixed(1)} 小时, `;
          //     }
          //     if (res.length > 0) {
          //       res = res.substring(0, res.length - 2);
          //     } else {
          //       res = "---";
          //     }
          //     return res;
          //   },
          // },
          {
            lable:
              this.$lange == "en" ? "技术改造（小时）" : "技术改造（小时）",
            render: (row) => {
              let arr = row.somethingElseList;
              let res = "";
              for (let i in arr) {
                if (arr[i].name == "技术改造") {
                  res = `${arr[i].value}`;
                }
              }
              if (res.length > 0) {
              } else {
                res = "---";
              }
              return res;
            },
            minWidth: 120,
          },
          {
            lable:
              this.$lange == "en"
                ? "质量问题返工（小时）"
                : "质量问题返工（小时）",
            render: (row) => {
              // return 1;
              let arr = row.somethingElseList;
              let res = "";
              for (let i in arr) {
                if (arr[i].name == "质量问题返工") {
                  res = `${arr[i].value}`;
                }
              }
              if (res.length > 0) {
              } else {
                res = "---";
              }
              return res;
            },
            minWidth: 150,
          },
          {
            lable:
              this.$lange == "en" ? "非工时日报（小时）" : "非工时日报（小时）",
            render: (row) => {
              // return 1;
              let arr = row.somethingElseList;
              let res = "";
              for (let i in arr) {
                if (arr[i].name == "非工时日报") {
                  res = `${arr[i].value}`;
                }
              }
              if (res.length > 0) {
              } else {
                res = "---";
              }
              return res;
            },
            minWidth: 130,
          },
          {
            lable: this.$lange == "en" ? "其余事项名称" : "其余事项名称",
            render: (row) => {
              // return 1;
              let arr = row.somethingElseList;
              let res = "";
              for (let i in arr) {
                if (arr[i].name == "其余事项") {
                  res = `${arr[i].remark}`;
                }
              }
              if (res.length > 0) {
              } else {
                res = "---";
              }
              return res;
            },
            minWidth: 150,
          },
          {
            lable:
              this.$lange == "en" ? "其余事项（小时）" : "其余事项（小时）",
            render: (row) => {
              let arr = row.somethingElseList;
              let res = "";
              for (let i in arr) {
                if (arr[i].name == "其余事项") {
                  res = `${arr[i].value}`;
                }
              }
              if (res.length > 0) {
              } else {
                res = "---";
              }
              return res;
            },
            minWidth: 120,
          },
          {
            lable: this.$lange == "en" ? "Presentation time" : "提报时间",
            render: (row) => {
              return moment(row.dailyTime).format("YYYY-MM-DD");
            },
            minWidth: 120,
          },

          {
            prop: "dailyExtAudit",
            lable: this.$lange == "en" ? "Audit status" : "审核状态",
            type: "tag",
            options: [
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Unaudited" : "未审核",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Audit pass" : "审核通过",
              },
              {
                tagType: "danger",
                text: this.$lange == "en" ? "Audit failed" : "审核不通过",
              },
            ],
            minWidth: 100,
          },
        ],
      },
      text: "",
      openAuditDialog: false,
      auditObj: {},
      auditFrom: {},
      adminUser: {},
      index: null,
      closeDialog: false,
      closeData: {},
    };
  },
  methods: {
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    getDataRemark(rows) {
      let somethingElseList = 0;
      let workshopDailyDetailsList = 0;
      for (let index = 0; index < rows.somethingElseList.length; index++) {
        somethingElseList = this.accAdd(
          rows.somethingElseList[index].value,
          somethingElseList
        );
      }
      for (
        let index = 0;
        index < rows.workshopDailyDetailsList.length;
        index++
      ) {
        workshopDailyDetailsList = this.accAdd(
          rows.workshopDailyDetailsList[index].actualWorkingHours,
          workshopDailyDetailsList
        );
      }
      let allTime = this.accAdd(somethingElseList, workshopDailyDetailsList);
      if (allTime < 8) {
        return "工时<8小时";
      }
      return "";
    },
    getisAudit(e) {
      if (e == 0) {
        return "待审核";
      } else if (e == 1) {
        return "审核通过";
      } else if (e == 2) {
        return "退回";
      }
    },
    status(e) {
      return ["info", "success", "danger"][e];
    },
    doSearch() {
      if (this.dailyTableParams.type === 0) {
        this.dailyTableParams1 = JSON.parse(
          JSON.stringify(this.dailyTableParams)
        );
      } else {
        this.dailyTableParams2 = JSON.parse(
          JSON.stringify(this.dailyTableParams)
        );
      }
    },
    exportReport() {
      // let url = `admin/fsb/workshop/daily/workshopDailyExport?appId=fosber`;
      let url =
        "admin/fsb/workshop/daily/workshopDailyExportFromReview?appId=fosber";
      if (this.dailyTableParams.type === 1) {
        // url = `admin/fsb/workshop/daily/otherDailyExport?appId=fosber`;
        url = `admin/fsb/workshop/daily/otherDailyExportFromReview?appId=fosber`;
      }
      for (let i in this.dailyTableParams) {
        if (this.dailyTableParams[i] !== "") {
          if (i == "startTime") {
            url += `&dailyStartTime=${this.dailyTableParams[i]}`;
          } else if (i == "endTime") {
            url += `&dailyEndTime=${this.dailyTableParams[i]}`;
          } else {
            url += `&${i}=${this.dailyTableParams[i]}`;
          }
        }
      }
      // url = url.substring(0, url.length - 2);
      console.log(url);
      window.open(`${this.$apis.config.server}${url}`);
    },
    dailyTableParamsTypeChange() {
      if (this.dailyTableParams.type === 0) {
        this.dailyTableParams1 = JSON.parse(
          JSON.stringify(this.dailyTableParams)
        );
      } else {
        this.dailyTableParams2 = JSON.parse(
          JSON.stringify(this.dailyTableParams)
        );
      }
      // this.refeshParams = new Date().getTime();  //用于切换表格类型的时候显示错误来刷新表格, 暂无发现, 先隐藏
    },
    selectChange(res) {
      console.log(res);
      this.dailyTableParams.deptId = res[res.length - 1];
    },

    dialogClose() {
      this.isAudit = false;
      this.editData = false;
      this.editForm = {
        ids: [],
        isAudit: 1,
        opinion: "",
      };
    },
    timeChange(res) {
      if (res) {
        this.dailyTableParams.startTime = res[0];
        this.dailyTableParams.endTime = res[1];
      } else {
        this.dailyTableParams.startTime = "";
        this.dailyTableParams.endTime = "";
      }
    },
    dailyTableSelectedIds(res) {
      this.editForm.ids = res;
    },
    //初始化树形控件的数据
    initClassList(data) {
      for (let i in data) {
        data[i].label = data[i].fullname;
        data[i].value = data[i].id;
        if (data[i].children.length > 0) {
          this.initClassList(data[i].children);
        } else {
          delete data[i].children;
        }
      }
    },
    getClassList() {
      this.ccRequest
        .do("admin/fsb/workshop/unit/getDeptList", {}, "GET")
        .then((res) => {
          this.classList = res;
          this.initClassList(this.classList);
          console.log(this.classList);
          // console.log(newData)
        });
    },
    getData() {
      this.getClassList();
    },
    close() {
      this.dialogEditor = false;
    },
    update() {
      this.dialogEditor = false;
      this.editDialog = false;
      this.getData();
      this.refeshParams = new Date().getTime();
    },
    getAllCount(data) {
      let time = 0;
      for (let index = 0; index < data.somethingElseList.length; index++) {
        time += data.somethingElseList[index].value;
      }
      for (
        let index = 0;
        index < data.workshopDailyDetailsList.length;
        index++
      ) {
        time += data.workshopDailyDetailsList[index].actualWorkingHours;
      }
      return time;
    },
    openAudit(e, isSomethingExt, index) {
      if (!isSomethingExt) {
        if (!this.auditObj[e.workshopProcessId]) {
          this.auditObj[e.workshopProcessId] = {
            processId: e.workshopProcessId,
            isAudit: 1,
            auditOpinion: "",
            auditUserId: this.adminUser.id,
            isSomethingExt: false,
            editType: 0,
          };
          this.auditFrom = {
            processId: e.workshopProcessId,
            isAudit: 1,
            auditOpinion: "",
            auditUserId: this.adminUser.id,
            isSomethingExt: false,
            editType: 0,
          };
        } else {
          this.auditFrom = {
            ...this.auditObj[e.workshopProcessId],
          };
        }
        this.index = index;
      } else {
        if (!this.auditObj["isSomethingExt"]) {
          this.auditObj["isSomethingExt"] = {
            isAudit: 1,
            auditOpinion: "",
            auditUserId: this.adminUser.id,
            isSomethingExt: true,
            editType: 0,
          };
          this.auditFrom = {
            isAudit: 1,
            auditOpinion: "",
            auditUserId: this.adminUser.id,
            isSomethingExt: true,
            editType: 0,
          };
        } else {
          this.auditFrom = {
            ...this.auditObj["isSomethingExt"],
          };
        }
        this.index = null;
      }
      this.openAuditDialog = true;
      console.log(this.auditObj, e);
    },
    editAudit() {
      if (this.auditFrom.isSomethingExt == false) {
        this.auditObj[this.auditFrom.processId] = this.auditFrom;
        this.auditObj[this.auditFrom.processId].editType = 1;
        this.editData.workshopDailyDetailsList[this.index].isAuditView =
          this.auditFrom.isAudit;
        this.editData.workshopDailyDetailsList[this.index].editType = 1;
      } else {
        this.auditObj["isSomethingExt"] = this.auditFrom;
        this.auditObj["isSomethingExt"].editType = 1;
        this.editData.dailyExtAuditView = this.auditFrom.isAudit;
        this.editData.editType = 1;
      }
      console.log(this.editData);
      this.openAuditDialog = false;
    },
    submitAudit() {
      let data = {
        dailyId: this.editData.id,
        reviewList: [
          // {
          //   processId: "1498489145101787137",
          //   isAudit: "1",
          //   auditOpinion: "",
          //   auditUserId: "1",
          //   isSomethingExt: false,
          // },
        ],
      };
      for (const key in this.auditObj) {
        data.reviewList.push(this.auditObj[key]);
      }
      if (data.reviewList.length == 0) {
        this.$message({
          type: "error",
          message: "最少审核一项内容",
        });
        return false;
      }
      console.log(data, this.editData, this.adminUser);

      this.ccRequest
        .do(`admin/fsb/workshop/daily/batchReview`, data, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: this.language("workShop.审核成功"),
          });
          this.isAudit = false;
          this.editDialog=false
          this.refeshParams = new Date().getTime();
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    doCloseDay() {
      if (!this.closeData.remark || this.closeData.remark == "") {
        this.$message.error(this.language("awaitDaily_dailyList.请先输入备注"));
        return false;
      }
      let data = {
        dailyId: this.closeData.id,
        remark: this.closeData.remark,
      };
      this.ccRequest
        .do("admin/fsb/workshop/daily/closeWorkshopDailyById", data, "GET")
        .then((res) => {
          this.$message.success(this.language("awaitDaily_dailyList.操作成功"));
          this.closeDialog = false;
          this.refeshParams = new Date().getTime();
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    getTime(e) {
      return moment(e).format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.getData();
    this.getValidate()
      .then((res) => {
        // res.id = "";
        // res.id = "117";
        this.adminUser = res;
        // this.adminUser.roleTips = 'management'
        if (this.adminUser.roleTips == "management") {
          this.dailyTableConfig.buttons = [
            {
              name: this.$lange == "en" ? "View and review" : "查看并审核",
              click: (row) => {
                let showAuditbutton = false;
                for (
                  let index = 0;
                  index < row.workshopDailyDetailsList.length;
                  index++
                ) {
                  row.workshopDailyDetailsList[index].isAuditView =
                    row.workshopDailyDetailsList[index].isAudit;
                  if (
                    row.workshopDailyDetailsList[index].auditId ==
                    this.adminUser.id
                  ) {
                    showAuditbutton = true;
                  }
                }
                if (this.adminUser.id == row.auditUserId) {
                  showAuditbutton = true;
                }
                this.showAuditbutton = showAuditbutton;
                row.dailyExtAuditView = row.dailyExtAudit;
                this.auditObj = {};
                this.auditFrom = {};
                this.editData = row;
                this.editForm.ids = [row.id];
                this.editDialog = true;
                this.isAudit = true;
              },
              check: (row) => {
                if (row.isAudit == 0) {
                  return true;
                } else {
                  return false;
                }
              },
            },

            {
              name: this.$lange == "en" ? "View Detail" : "查看",
              check: (row) => {
                let res = false;
                if (row.isAudit !== 0) {
                  res = true;
                }
                return res;
              },
              click: (row) => {
                for (
                  let index = 0;
                  index < row.workshopDailyDetailsList.length;
                  index++
                ) {
                  row.workshopDailyDetailsList[index].isAuditView =
                    row.workshopDailyDetailsList[index].isAudit;
                }
                row.dailyExtAuditView = row.dailyExtAudit;

                this.auditObj = {};
                this.auditFrom = {};
                this.editData = row;
                this.editDialog = true;
              },
            },
            {
              name: this.language("awaitDaily_dailyList.关闭"),
              click: (row) => {
                this.closeData = row;
                this.closeDialog = true;
              },
              check: (e) => {
                let type = false;
                if (e.isAudit == 2) {
                  type = true;
                }
                return type;
              },
            },
            // {
            //   name: "", //占位
            // },
          ];
        }
      })
      .catch(() => {});
  },
};
</script>

<style scoped lang="scss">
.p span {
  // margin-right: 10px;
  display: block;
  min-width: 50px;
  text-align: center;
}
.p .span1 {
  // width: 86px;
}
.input {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .button {
    margin-left: 10px;
  }
}
.p {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.daily-report {
  .top {
    padding: 20px;
    justify-content: flex-start;
    > * {
      margin-right: 20px;
      > span {
        margin-right: 5px;
        width: 35px;
      }
    }
  }
}

.bottom {
  padding: 20px;
}
.edit-dialog {
  .user-info {
    justify-content: flex-start;
    p {
      font-size: 18px;
      margin-right: 20px;
    }
    span {
      font-size: 12px;
    }
  }
  .lists-item {
    margin: 10px 0;
    .list {
      // border: 1px solid #c3c3c3;
      // background-color: #f5f7fa;
      // border-color: #dce0eb;
      background: #1ab394;

      // border-width: 1px;
      // border-style: solid;
      // padding: 10px 20px;
      margin-bottom: 20px;
      .list-left {
        // padding: 0 20px ;
        flex-wrap: wrap;
        width: 100%;
        padding-bottom: 5px;
        // div {
        //   margin: 10px 0;
        //   font-size: 14px;
        //   color: #6f6f6f;
        //   width: 100%;
        // }
        // span {
        //   font-size: 14px;

        //   // opacity: 0.8;
        //   width: 20%;
        //   margin: 5px 5px 5px 0;
        //   &:nth-child(2n-1) {
        //     width: 70%;
        //   }
        // }
      }
      .list-right {
        margin-bottom: auto;
      }
      .list-left {
        width: 99%;
        margin: 0 auto;
      }
    }
    .back {
      background: #f5f7fa;
      padding: 10px;
      width: 100%;
      font-weight: 700;
      box-sizing: border-box;
    }
    .audit_wrap {
      color: #fff;
      display: flex;
      padding: 10px;
      font-weight: 700;
    }
    .list-left {
      display: flex;
      .li {
        display: flex;
        padding: 10px 0;
      }
      .count {
        border-top: 1px solid #d7dae2;
        padding: 10px 0;
      }
    }
  }
  .remake {
    margin-top: 20px;
    margin-bottom: 15px;
    .title {
      font-size: 16px;
    }
    .content {
      margin-top: 5px;
      opacity: 0.75;
    }
  }
  .btn-group {
    margin-top: 30px;
    justify-content: center;
    * {
      margin: 0 10px;
    }
  }
  .all_count {
    color: rgba(26, 179, 148, 1);
    font-weight: 700;
  }
}
.color-0 {
  color: #909399;
}
.color-1 {
  color: #409eff;
}
.color-2 {
  color: #f56c6c;
}
.row-clip div {
  //   word-wrap: break-word;
  //   word-break: break-all;
}
.userName {
  font-weight: 700;
}
.font_weight {
  font-weight: 700;
}
.title_data {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 14px;
  .li {
    margin: 10px 0;
    width: 200px;
    font-weight: 700;
    display: flex;
    align-items: center;
    span {
      margin-right: 10px;
    }
  }
  .li_time {
    width: 300px;
    position: relative;
    span {
      // width: 80px;
    }
  }
}
.title_wrap {
  display: flex;
  align-items: center;
  h4 {
    padding: 10px 20px 10px 0;
  }
}

.result {
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    color: #1ab394;
    margin-right: 10px;
  }
  h3 {
    margin-bottom: 5px;
  }
}

// .card_wrap {
.title_wrap {
  display: flex;
  align-items: center;
  h4 {
    padding: 10px 20px 10px 0;
  }
}
.card_box {
  margin-bottom: 20px;
  min-height: 120px;
  background-color: rgb(245, 247, 250);
  border-color: rgb(220, 224, 235);
  border-width: 1px;
  border-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  .right2 {
    position: absolute;
    right: 0px;
    top: 20px;
    width: 100px;
    div {
      margin-bottom: 20px;
    }
  }
  .right {
    position: absolute;
    right: 0px;
    top: 20px;
    width: 100px;
    div {
      margin-bottom: 20px;
    }
  }
}
.selete_data {
  font-size: 14px;
  font-weight: 700;
  width: 100%;
  min-height: 120px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  .li_data {
    margin-bottom: 10px;
  }
  .li_data_2 {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      width: 80%;
      .title {
        min-width: 50px;
      }
    }
  }
  .li_data3 {
    padding-bottom: 20px !important;
    margin-bottom: 20px !important;
    border-bottom: 1px solid #dce0eb !important;
  }
}
.text {
  color: #d7001b;
}
// }

.remark {
  margin-top: 10px;
  display: flex;
  div {
    white-space: pre;
    // display: flex;
    // align-items: center;
  }
}
.audit_botton {
  display: flex;
  justify-content: center;
}
.itme {
  display: flex;
  align-items: center;
}

p,
h2,
h3 {
  text-align: center;
}
h2 {
  margin-bottom: 10px;
}
.userDay {
  margin-top: 40px;
}

h3 {
  margin-bottom: 5px;
}
.textarea {
  width: 80%;
  margin: 20px auto 0 auto;
}
.button_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.day_num {
  margin: 0 0 0 40px;
}
</style>
